define( function() {
	return ( /^(?:checkbox|radio)$/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rcheckableType.js
// module id = 544
// module chunks = 349